import { store as signatureStore } from 'owa-mail-signature/lib/store/signatureStore';
import { ComposeViewState } from 'owa-mail-compose-store';
import insertSignature from 'owa-mail-compose-actions/lib/utils/insertSignature';
import { SurfaceActionItem } from 'owa-surface-actions';
const styles = require('../components/ComposeCommandingBar.scss');

export default function getInsertSignatureDropdown(
    composeViewState: ComposeViewState
): SurfaceActionItem[] {
    const { roamingSignatureMap } = signatureStore;
    if (roamingSignatureMap.size == 0) {
        return null;
    }

    const insertSignatureDropdown = [];
    roamingSignatureMap.forEach(signature => {
        let signatureName;
        if (signature.html) {
            signatureName = signature.html.name;
        } else if (signature.txt) {
            signatureName = signature.txt.name;
        } else {
            return;
        }
        insertSignatureDropdown.push({
            name: signatureName,
            title: signatureName,
            className: styles.composeCommandingBarItem,
            onClick: () => {
                insertSignature(composeViewState, signature /*roamingSignature */);
            },
            key: signatureName,
        });
    });
    return insertSignatureDropdown;
}
